import { combineReducers } from 'redux';
import { freeze } from 'icepick';
import { RETRIEVE_SUCCESS, type SummaryLoadSuccessAction } from '../actions/retrieve';
import entities from './entities/reducer';
import result from './result/reducer';
import type { PersistedState } from './types';

const childReducers = combineReducers({
	result,
	entities,
});

type Actions = SummaryLoadSuccessAction;

const handleActions = (state: PersistedState | undefined, action: Actions) => {
	switch (action.type) {
		case RETRIEVE_SUCCESS: {
			const summaryPage: PersistedState = action.payload;
			return freeze(summaryPage);
		}
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: PersistedState, action: Actions) =>
	// @ts-expect-error - Argument of type 'SummaryPage | undefined' is not assignable to parameter of type 'CombinedState<{ result: never; entities: SummaryEntities; }> | undefined'.
	childReducers(handleActions(state, action), action);
